// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2Z5PL","center":"Loading_center__2EAK7","spinner":"Loading_spinner__3EkUG","rotate":"Loading_rotate__1Wpb6"};